module.exports = new Promise(function (resolve, reject) {
    var __webpack_error__ = new Error();

    if (typeof window["parentalControl"] !== 'undefined') {
      return resolve();
    }

    __webpack_require__.l(
      window["parentalControlRemoteUrl"] + '/remote-entry-parental-control.js',
      function (event) {
        if (typeof window["parentalControl"] !== 'undefined') {
           return resolve();
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        reject(__webpack_error__);
      },
      "parentalControl",
    );
  }).then(function(){
    var proxy = {
      get: window["parentalControl"].get,
      init: window["parentalControl"].init
    }
    return proxy
  }).catch(function(e) {
    console.error('parentalControl', e);
    let newProxy = {
      get: (module, scope) => () => [],
      init: () => {}
    }
    return(newProxy);
  });